import './App.css';
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Home from './components/Home';
import Sidebar from './components/Header components/Sidebar';
import Splash from './components/Splash components/Splash';
import NeuralGateway from './components/NeuralGateway';

function App() {
  const [lines, setLines] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showGateway, setShowGateway] = useState(false);
  const [darkMode, setDarkMode] = useState(false);

  // Initialize dark mode from localStorage or system preference
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

    if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
      setDarkMode(true);
      document.documentElement.classList.add('dark');
    }
  }, []);

  const toggleLines = () => {
    setLines(!lines);
  };

  const setLoaders = (loading = true, done = false, skip = false) => {
    setLoading(loading);

    // When splash is done, show neural gateway
    if (!loading && done && !skip) {
      setShowGateway(true);
    }

    // If skip is true, go directly to portfolio
    if (!loading && skip) {
      setShowGateway(false);
    }

    // If done but not skip, show gateway
    if (!loading && done && !skip) {
      setShowGateway(true);
    }
  };

  const handleEnterPortfolio = () => {
    setShowGateway(false);
  };

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    if (!darkMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  };

  return (
    <div className={`portfolio min-h-screen transition-colors duration-300 ${
      darkMode ? 'dark bg-dark-900' : 'bg-gray-50'
    }`}>
      <AnimatePresence mode="wait">
        {loading && (
          <motion.div
            key="splash"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Splash value={setLoaders} />
          </motion.div>
        )}
      </AnimatePresence>

      {/* Neural Gateway - Shows after splash, before main portfolio */}
      <AnimatePresence>
        {showGateway && !loading && (
          <NeuralGateway onEnterPortfolio={handleEnterPortfolio} />
        )}
      </AnimatePresence>

      {/* Main Portfolio - Shows after gateway */}
      {!loading && !showGateway && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="flex"
        >
          <Sidebar
            value={{
              lines,
              setLines: toggleLines,
              darkMode,
              toggleDarkMode
            }}
          />
          <Home
            value={{
              lines,
              setLines: toggleLines,
              darkMode
            }}
          />
        </motion.div>
      )}
    </div>
  );
}

export default App;
